module.exports = function getResource(label, vars = []) {
    let resources = {
        hours: 'Heures',
        openTodayUntil: 'Ouvert aujourd’hui jusqu’à'
    };

    return resources[label];
};
